<script lang="ts">
	export let label = 'dev enabled';
</script>

<div class="dev-enabled-option">
	<slot />
	<span class="dev-enabled-badge">{label}</span>
</div>

<style>
	.dev-enabled-option {
		position: relative;
		width: 100%;
	}

	.dev-enabled-badge {
		position: absolute;
		top: -7px;
		right: 8px;
		z-index: 1;
		padding: 1px 6px;
		border-radius: 4px;
		background: var(--color-warning, #ffc51d);
		color: #111;
		font-size: 9px;
		font-weight: 700;
		letter-spacing: 0.04em;
		line-height: 1.3;
		text-transform: uppercase;
		white-space: nowrap;
		pointer-events: none;
	}
</style>
